export default __webpack_public_path__ + "static/media/dashBoard_active.e2aa6170.svg";